module.exports = __webpack_public_path__ + "img/google.b7727941.svg";